export default __webpack_public_path__ + "static/polka-pets-504b5458857fcc431c9d24702a57ecc1.png";